<div formGroupName="appliInfoChild">
  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="fill"
      class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
      <mat-label>登録日</mat-label>
      <input matInput readonly="true" formControlName="tourokuYMD" class="font-color-display-only"/>
    </mat-form-field>

    <mat-form-field appearance="fill" class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
      <mat-label>登録時刻</mat-label>
      <input matInput readonly="true" formControlName="tourokuTIME" class="font-color-display-only"/>
    </mat-form-field>

    <mat-form-field appearance="fill" class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>登録担当部署</mat-label>
      <input matInput readonly="true" formControlName="tourokuTantouBusho" class="font-color-display-only"/>
    </mat-form-field>

    <mat-form-field appearance="fill" class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>登録担当者</mat-label>
      <input matInput readonly="true" formControlName="tourokuTantosha" class="font-color-display-only"/>
    </mat-form-field>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="fill" class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
      <mat-label>最終更新日</mat-label>
      <input matInput readonly="true" formControlName="saishuKousinYMD" class="font-color-display-only"/>
    </mat-form-field>

    <mat-form-field appearance="fill" class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
      <mat-label>最終更新時刻</mat-label>
      <input matInput readonly="true" formControlName="saishuKousinTIME" class="font-color-display-only"/>
    </mat-form-field>

    <mat-form-field appearance="fill" class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>最終更新担当部署</mat-label>
      <input matInput readonly="true" formControlName="saishuKousinTantouBusho" class="font-color-display-only"/>
    </mat-form-field>

    <mat-form-field appearance="fill" class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>最終更新担当者</mat-label>
      <input matInput readonly="true" formControlName="saishuKousinTantosha" class="font-color-display-only"/>
    </mat-form-field>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="fill" class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
      <mat-label>承認日</mat-label>
      <input matInput readonly="true" formControlName="shoninYMD" class="font-color-display-only"/>
    </mat-form-field>

    <mat-form-field appearance="fill" class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
      <mat-label>承認時刻</mat-label>
      <input matInput readonly="true" formControlName="shoninTIME" class="font-color-display-only"/>
    </mat-form-field>

    <mat-form-field appearance="fill" class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>承認担当部署</mat-label>
      <input matInput readonly="true" formControlName="shoninTantouBusho" class="font-color-display-only"/>
    </mat-form-field>

    <mat-form-field appearance="fill" class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>承認担当者</mat-label>
      <input matInput readonly="true" formControlName="shoninTantosha" class="font-color-display-only"/>
    </mat-form-field>
  </div>
</div>
